/* ============================================================
   DOGS SUPREME · <ds-nav-planer>
   7-/14-Tage-Umstellungsplaner (Navigator P2, docs/navigator-plattform.md).

   Fachlogik:
   · Zielration neues Futter = Futterfibel-Staffel (2/1,8/4 % vom
     Koerpergewicht, identisch ds-futter-rechner; # vereinfachung:
     Formel bewusst dupliziert, Decke: bei 3. Kopie gemeinsames Asset).
   · ALTES Futter wird als ANTEIL DER GEWOHNTEN PORTION angegeben
     (75/50/25 %), NICHT in Gramm: Trockenfutter ist konzentrierter,
     eine 1:1-Gramm-Angabe waere fachlich falsch.
   · NEUES Futter in Gramm aus der Zielration (25/50/75/100 %).
   · Welpe -> kein Plan (Hinweis). Senior -> Staffel ja, Mengen an
     bisheriger Portion orientieren (keine Automatik-Gramm).
   · Vorbefuellung aus dem Check: resolvePrefill(), der JUENGERE
     Stand gewinnt (savedAt-Vergleich, Design-Spec 3.7).
   · Zeigt der Check-State rote Flags: Hinweis-Banner VOR dem
     Formular (kein Hard-Block, aber kein kommentarloses Planen).
   · Druck-Ansicht mit Abhak-Kaestchen je Phase.
   · EINE Bridge: Kennenlern-Box (Vertrag ai_bridge_click_umstellungsplan_planer_kennenlern-box).

   UI-Schicht: assets/ds-nav-foundation.css (.dsn-*), Spec
   docs/standards/navigator-design-spec.md. injectStyles traegt nur
   Widget-Individuelles; ensureFoundation() laedt die Foundation nach,
   falls die Section sie nicht traegt.

   Kompatibilitaet wie ds-audio.js (ES2015, keine #-Felder, kein
   Optional-Chaining), localStorage ds_nav_planer_v1.
   ============================================================ */
(function () {
  'use strict';

  var FACTORS = { normal: 0.02, mollig: 0.018, duenn: 0.04 };
  function round5(n) { return Math.round(n / 5) * 5; }
  function computeRation(kg, zustand) {
    var f = FACTORS[zustand];
    if (!f || typeof kg !== 'number' || !isFinite(kg) || kg <= 0) return null;
    var perDay = round5(kg * 1000 * f);
    return { gramsPerDay: perDay, gramsPerMeal: round5(perDay / 2), factor: f };
  }

  /* Phasen des Uebergangs: alt = % der gewohnten Portion, neu = % der Zielration */
  function phases(slow) {
    if (slow) {
      return [
        { tage: 'Tag 1 bis 3', alt: 75, neu: 25 },
        { tage: 'Tag 4 bis 7', alt: 50, neu: 50 },
        { tage: 'Tag 8 bis 11', alt: 25, neu: 75 },
        { tage: 'ab Tag 12', alt: 0, neu: 100 }
      ];
    }
    return [
      { tage: 'Tag 1 und 2', alt: 75, neu: 25 },
      { tage: 'Tag 3 und 4', alt: 50, neu: 50 },
      { tage: 'Tag 5 und 6', alt: 25, neu: 75 },
      { tage: 'ab Tag 7', alt: 0, neu: 100 }
    ];
  }

  /* Plan-Zeilen: neue Gramm je Phase aus Zielration, alt als Portions-Anteil. */
  function planRows(kg, zustand, slow) {
    var r = computeRation(kg, zustand);
    if (!r) return null;
    return phases(slow).map(function (p) {
      return {
        tage: p.tage, altPct: p.alt,
        neuGrams: round5(r.gramsPerDay * p.neu / 100),
        neuPct: p.neu
      };
    });
  }

  function boxDays(boxGrams, gramsPerDay) {
    if (!(boxGrams > 0) || !(gramsPerDay > 0)) return null;
    var d = Math.round(boxGrams / gramsPerDay);
    if (d < 2 || d > 60) return null;
    return d;
  }

  /* ---------- Prefill-Aufloesung (pur, Node-testbar) ----------
     Der juengere Stand gewinnt: hat der Check frischere Daten als der
     Planer (savedAt), uebernehmen wir kg/figur/alter aus dem Check
     (tempo bleibt Planer-Sache). Fehlendes savedAt zaehlt als alt (0).
     Rueckgabe { kg, figur, alter, tempo, fromCheck }                    */
  function resolvePrefill(planerState, checkState) {
    var base = { kg: '', figur: 'normal', tempo: 'normal', alter: 'erwachsen' };
    var p = planerState || null;
    var c = checkState || null;
    var out = {
      kg: p && p.kg ? p.kg : base.kg,
      figur: p && p.figur ? p.figur : base.figur,
      tempo: p && p.tempo ? p.tempo : base.tempo,
      alter: p && p.alter ? p.alter : base.alter,
      fromCheck: false
    };
    if (!c || !c.kg) return out;
    var pT = p && p.savedAt ? Date.parse(p.savedAt) || 0 : 0;
    var cT = c.savedAt ? Date.parse(c.savedAt) || 0 : 0;
    var planerLeer = !p || !p.kg;
    if (planerLeer || cT > pT) {
      out.kg = c.kg;
      if (c.figur) out.figur = c.figur;
      if (c.alter) out.alter = c.alter;
      out.fromCheck = true;
    }
    return out;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { planRows: planRows, phases: phases, computeRation: computeRation, boxDays: boxDays, FACTORS: FACTORS, resolvePrefill: resolvePrefill };
    return;
  }

  if (!('customElements' in window) || customElements.get('ds-nav-planer')) return;

  var LS_KEY = 'ds_nav_planer_v1';
  var CHECK_KEY = 'ds_nav_check_v1';

  function ensureFoundation() {
    if (document.getElementById('dsn-foundation')) return;
    var probe = document.querySelector('link[href*="ds-nav-foundation"]');
    if (probe) { probe.id = probe.id || 'dsn-foundation'; return; }
    var self = document.querySelector('script[src*="ds-nav-planer"]');
    if (!self) return;
    var link = document.createElement('link');
    link.id = 'dsn-foundation';
    link.rel = 'stylesheet';
    link.href = self.src.split('?')[0].replace(/ds-nav-planer\.js$/, 'ds-nav-foundation.css');
    document.head.appendChild(link);
  }

  function injectStyles() {
    if (document.getElementById('ds-nav-planer-styles')) return;
    var style = document.createElement('style');
    style.id = 'ds-nav-planer-styles';
    style.textContent = [
      "ds-nav-planer .dsnp-prefill{font-size:13px;color:#0071e3;margin:0 0 14px}",
      "ds-nav-planer .dsnp-result{display:none;margin-top:20px}",
      "ds-nav-planer .dsnp-result.dsnp-show{display:block}",
      "ds-nav-planer .dsnp-phase{display:flex;gap:14px;align-items:flex-start}",
      "ds-nav-planer .dsnp-check{flex:0 0 auto;width:24px;height:24px;border-radius:50%;border:1.5px solid #d2d2d7;margin-top:2px}",
      "ds-nav-planer .dsnp-phase-body{flex:1 1 auto}",
      "ds-nav-planer .dsnp-phase-title{font-size:15px;font-weight:600;color:#1d1d1f;margin:0 0 4px}",
      "ds-nav-planer .dsnp-phase-text{font-size:14px;color:#6e6e73;line-height:1.5;margin:0}",
      "ds-nav-planer .dsnp-phase-text b{color:#1d1d1f;font-variant-numeric:tabular-nums}",
      "ds-nav-planer .dsnp-actions{display:flex;flex-wrap:wrap;gap:10px;margin-top:14px}",
      "@media (max-width:480px){ds-nav-planer .dsnp-actions{flex-direction:column;align-items:stretch}}",
      "@media print{body *{visibility:hidden}ds-nav-planer,ds-nav-planer *{visibility:visible}",
      "ds-nav-planer{position:absolute;left:0;top:0;width:100%}",
      "ds-nav-planer .dsnp-actions,ds-nav-planer .dsn-btn,ds-nav-planer .dsnp-bridge,ds-nav-planer .dsn-alert{display:none!important}",
      "ds-nav-planer .dsn-card{border:none;box-shadow:none;padding:0}}"
    ].join('');
    document.head.appendChild(style);
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  var ARROW_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="12" x2="19" y2="12"></line><polyline points="13 6 19 12 13 18"></polyline></svg>';

  class DsNavPlaner extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      ensureFoundation();
      injectStyles();

      this.boxUrl = this.getAttribute('box-url') || '/products/barf-kennenlern-box';
      this.boxGrams = parseInt(this.getAttribute('box-grams') || '2000', 10);
      this.checkUrl = this.getAttribute('check-url') || '/pages/futterwechsel-check';

      var planerState = this.load();
      var checkState = this.loadCheck();
      var resolved = resolvePrefill(planerState, checkState);
      this.state = { kg: resolved.kg, figur: resolved.figur, tempo: resolved.tempo, alter: resolved.alter };
      if (planerState && planerState.savedAt) this.state.savedAt = planerState.savedAt;
      this.prefilled = resolved.fromCheck;
      this.checkFlags = checkState && checkState.flags ? checkState.flags : [];
      this.render();
    }

    load() {
      try { var raw = localStorage.getItem(LS_KEY); return raw ? JSON.parse(raw) : null; }
      catch (e) { return null; }
    }
    loadCheck() {
      try { var raw = localStorage.getItem(CHECK_KEY); return raw ? JSON.parse(raw) : null; }
      catch (e) { return null; }
    }
    save() {
      try {
        this.state.savedAt = new Date().toISOString();
        localStorage.setItem(LS_KEY, JSON.stringify(this.state));
      } catch (e) {}
    }

    segRow(options, current, onChange) {
      var wrap = el('div', 'dsn-seg-track');
      options.forEach(function (opt) {
        var btn = el('button', 'dsn-seg', opt.label);
        btn.type = 'button';
        btn.setAttribute('aria-pressed', opt.v === current ? 'true' : 'false');
        btn.addEventListener('click', function () {
          var all = wrap.querySelectorAll('.dsn-seg');
          for (var i = 0; i < all.length; i++) all[i].setAttribute('aria-pressed', 'false');
          btn.setAttribute('aria-pressed', 'true');
          onChange(opt.v);
        });
        wrap.appendChild(btn);
      });
      return wrap;
    }

    render() {
      var self = this;
      var s = this.state;
      var card = el('div', 'dsn-card');

      card.appendChild(el('p', 'dsn-title', 'Dein Umstellungsplan'));
      card.appendChild(el('p', 'dsn-sub',
        'Altes Futter schrittweise runter, neues schrittweise rauf. Du bekommst die Staffel mit Mengen, zum Abhaken und Ausdrucken.'));

      if (this.checkFlags.length > 0) {
        var alert = el('div', 'dsn-alert dsn-alert--error');
        alert.appendChild(document.createTextNode(
          'Dein Futterwechsel-Check hat Warnzeichen ergeben. Bitte kläre die zuerst in deiner Tierarztpraxis, bevor du umstellst. '));
        var alink = el('a', '', 'Zum Check');
        alink.href = this.checkUrl;
        alert.appendChild(alink);
        card.appendChild(alert);
      }

      if (this.prefilled) {
        card.appendChild(el('p', 'dsnp-prefill', 'Gewicht und Figur aus deinem Futterwechsel-Check übernommen.'));
      }

      var g1 = el('div', '');
      g1.style.marginBottom = '16px';
      var lbl = el('label', 'dsn-label', 'Gewicht in kg');
      lbl.setAttribute('for', 'DsnpKg');
      g1.appendChild(lbl);
      var field = el('div', 'dsn-field dsn-field--suffix');
      var input = el('input', 'dsn-input');
      input.id = 'DsnpKg'; input.type = 'number'; input.step = '0.1';
      input.min = '0.5'; input.max = '100'; input.placeholder = 'z. B. 20';
      input.setAttribute('inputmode', 'decimal');
      input.value = s.kg;
      field.appendChild(input);
      var suffix = el('span', 'dsn-suffix', 'kg');
      suffix.setAttribute('aria-hidden', 'true');
      field.appendChild(suffix);
      g1.appendChild(field);
      var errLine = el('p', 'dsn-error-line', 'Bitte ein Gewicht zwischen 0,5 und 100 kg eintragen.');
      errLine.style.display = 'none';
      g1.appendChild(errLine);
      card.appendChild(g1);
      this.input = input;
      this.errLine = errLine;

      var g2 = el('div', '');
      g2.style.marginBottom = '16px';
      g2.appendChild(el('span', 'dsn-label', 'Alter'));
      g2.appendChild(this.segRow(
        [{ v: 'welpe', label: 'Welpe' }, { v: 'erwachsen', label: 'Erwachsen' }, { v: 'senior', label: 'Senior' }],
        s.alter, function (v) { s.alter = v; self.save(); self.hideResult(); }));
      card.appendChild(g2);

      var g3 = el('div', '');
      g3.style.marginBottom = '16px';
      g3.appendChild(el('span', 'dsn-label', 'Figur'));
      g3.appendChild(this.segRow(
        [{ v: 'duenn', label: 'Zu dünn' }, { v: 'normal', label: 'Normal' }, { v: 'mollig', label: 'Etwas mollig' }],
        s.figur, function (v) { s.figur = v; self.save(); self.hideResult(); }));
      card.appendChild(g3);

      var g4 = el('div', '');
      g4.style.marginBottom = '4px';
      g4.appendChild(el('span', 'dsn-label', 'Tempo'));
      g4.appendChild(this.segRow(
        [{ v: 'normal', label: '7 Tage (Standard)' }, { v: 'slow', label: '14 Tage (behutsam)' }],
        s.tempo, function (v) { s.tempo = v; self.save(); self.hideResult(); }));
      card.appendChild(g4);

      var dock = el('div', 'dsn-dock');
      var btn = el('button', 'dsn-btn', 'Plan erstellen');
      btn.type = 'button';
      dock.appendChild(btn);
      card.appendChild(dock);
      this.buildBtn = btn;

      this.result = el('div', 'dsnp-result');
      this.result.setAttribute('aria-live', 'polite');
      card.appendChild(this.result);

      btn.addEventListener('click', function () { self.build(); });
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); self.build(); } });
      input.addEventListener('input', function () {
        input.classList.remove('dsn-invalid');
        errLine.style.display = 'none';
      });

      this.appendChild(card);
    }

    hideResult() {
      this.result.classList.remove('dsnp-show');
      this.buildBtn.textContent = 'Plan erstellen';
    }
    clearResult() { while (this.result.firstChild) this.result.removeChild(this.result.firstChild); }

    printBtn() {
      var b = el('button', 'dsn-btn dsn-btn--ghost dsn-btn--sm', 'Plan drucken');
      b.type = 'button';
      b.addEventListener('click', function () { window.print(); });
      return b;
    }

    build() {
      var s = this.state;
      s.kg = this.input.value; /* direkt aus dem DOM: Autofill/programmatische Fills feuern kein input-Event */
      this.save();
      this.clearResult();

      var kg = parseFloat(String(s.kg).replace(',', '.'));
      if (!isFinite(kg) || kg < 0.5 || kg > 100) {
        this.input.classList.add('dsn-invalid');
        this.errLine.style.display = 'block';
        this.input.focus();
        this.hideResult();
        return;
      }

      if (s.alter === 'welpe') {
        var w = el('div', 'dsn-result dsn-step-in');
        w.appendChild(el('p', 'dsn-text',
          'Für Welpen und Junghunde bauen wir bewusst keinen Automatik-Plan: Ration und Umstellung gehören ins Gespräch mit deiner Tierarztpraxis oder einer qualifizierten Ernährungsberatung.'));
        this.result.appendChild(w);
        this.result.classList.add('dsnp-show');
        this.buildBtn.textContent = 'Plan aktualisieren';
        return;
      }

      var senior = s.alter === 'senior';
      var slow = s.tempo === 'slow';
      var zustand = s.figur === 'duenn' ? 'duenn' : (s.figur === 'mollig' ? 'mollig' : 'normal');
      var rows = planRows(kg, zustand, slow);
      var ration = computeRation(kg, zustand);

      var box = el('div', 'dsn-result dsn-step-in');

      var sum = el('div', '');
      sum.style.marginBottom = '14px';
      if (senior) {
        sum.appendChild(el('p', 'dsn-text',
          'Beim Senior orientierst du die Gesamtmenge an der bisherigen Portion und sprichst Anpassungen mit deiner Tierarztpraxis ab. Die Staffel unten gilt trotzdem: altes Futter schrittweise runter, neues rauf.'));
      } else {
        var p1 = el('p', 'dsn-text');
        p1.appendChild(document.createTextNode('Zielration neues Futter: '));
        var b1 = el('b', 'dsn-num', 'ca. ' + ration.gramsPerDay + '\u00A0g pro Tag');
        p1.appendChild(b1);
        p1.appendChild(document.createTextNode(' (auf zwei Mahlzeiten: je ca. ' + ration.gramsPerMeal + ' g). Startwert, kein Dogma.'));
        sum.appendChild(p1);
      }
      box.appendChild(sum);

      rows.forEach(function (r) {
        var sc = el('div', 'dsn-subcard');
        var ph = el('div', 'dsnp-phase');
        ph.appendChild(el('span', 'dsnp-check'));
        var body = el('div', 'dsnp-phase-body');
        body.appendChild(el('p', 'dsnp-phase-title', r.tage));
        var txt = el('p', 'dsnp-phase-text');
        if (r.altPct > 0) {
          txt.appendChild(document.createTextNode(r.altPct + ' % deiner gewohnten Portion vom alten Futter, dazu '));
        } else {
          txt.appendChild(document.createTextNode('Nur noch neues Futter: '));
        }
        var bNeu = el('b', '', senior ? r.neuPct + '\u00A0% der Zielmenge' : 'ca. ' + r.neuGrams + '\u00A0g neues Futter');
        txt.appendChild(bNeu);
        txt.appendChild(document.createTextNode(r.altPct > 0 ? ' über den Tag verteilt.' : ' am Tag.'));
        body.appendChild(txt);
        ph.appendChild(body);
        sc.appendChild(ph);
        box.appendChild(sc);
      });

      var watch = el('div', 'dsn-subcard');
      var wp = el('p', 'dsnp-phase-text');
      wp.appendChild(el('b', '', 'Deine Kontrollpunkte je Phase: '));
      wp.appendChild(document.createTextNode(
        'Kot stabil? Appetit da? Energie normal? Haut ruhig? Wenn ja: nächste Phase. Wenn etwas kippt: eine Phase zurück und zwei, drei Tage Ruhe. Beim Umstieg von Trockenfutter wirkt die frische Menge größer, das ist normal: Frischfutter enthält Wasser, Trockenfutter nicht.'));
      watch.appendChild(wp);
      box.appendChild(watch);

      var bridge = el('div', 'dsn-subcard dsnp-bridge');
      bridge.appendChild(el('p', 'dsn-subcard-title', 'Passendes neues Futter zum Ausprobieren'));
      var days = ration ? boxDays(this.boxGrams, ration.gramsPerDay) : null;
      bridge.appendChild(el('p', 'dsn-text',
        'Die BARF Kennenlern-Box bringt fünf Sorten mit Innereien, zusammen 2 kg, roh und schockgefrostet vom Metzgermeister' +
        (days && !senior ? '. Bei deiner Zielration reicht sie etwa ' + days + ' Tage, genug für die ersten Phasen.' : '.')));
      var link = el('a', 'dsn-cta', 'BARF Kennenlern-Box ansehen');
      link.href = this.boxUrl + (this.boxUrl.indexOf('?') === -1 ? '?' : '&') + 'utm_source=ai-bridge';
      link.setAttribute('data-event', 'ai_bridge_click_umstellungsplan_planer_kennenlern-box');
      var arrow = el('span', '');
      arrow.innerHTML = ARROW_SVG;
      arrow.setAttribute('aria-hidden', 'true');
      link.appendChild(arrow);
      bridge.appendChild(link);
      box.appendChild(bridge);

      box.appendChild(el('p', 'dsn-note',
        'Startwerte für gesunde Hunde, keine tierärztliche Empfehlung. Krank, trächtig oder unsicher? Sprich den Wechsel mit deiner Tierarztpraxis ab.'));
      var actions = el('div', 'dsnp-actions');
      actions.appendChild(this.printBtn());
      box.appendChild(actions);

      this.result.appendChild(box);
      this.result.classList.add('dsnp-show');
      this.buildBtn.textContent = 'Plan aktualisieren';
      this.result.scrollIntoView({ block: 'start', behavior: 'auto' });
      window.scrollBy(0, -84);
    }
  }

  customElements.define('ds-nav-planer', DsNavPlaner);
})();
